import { Link, useStaticQuery, graphql } from "gatsby"
import React from "react"
import ReactHtmlParser from "react-html-parser"

const queryLayout = () => {
  return useStaticQuery(graphql`
    query {
      contentstackFooter {
        title
        uid
        logo {
          url
          title
        }
        navigation {
          link {
            href
            title
          }
        }
        social {
          social_share {
            link {
              href
              title
            }
            icon {
              url
              title
            }
          }
        }
        copyright
      }
    }
  `)
}

const Footer = props => {
  let data = props.data

  return (
    <footer>
      <div className="max-width footer-div">
        <div className="col-quarter">
          <Link to="/" className="logo-tag">
            {data && data.contentstackFooter && data && data.contentstackFooter.logo && <img
              src={data.contentstackFooter.logo.url}
              alt={data.contentstackFooter.title}
              title={data.contentstackFooter.title}
              className="logo footer-logo"
            />}
          </Link>
        </div>
        <div className="col-half">
          <nav>
            <ul className="nav-ul">
              {data && data.contentstackFooter && data.contentstackFooter.navigation && data.contentstackFooter.navigation.link.map((menu, index) => {
                return (
                  <li className="footer-nav-li" key={index}>
                    <Link to={menu.href}>{menu.title}</Link>
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
        <div className="col-quarter social-link">
          <div className="social-nav">
            {data && data.contentstackFooter && data.contentstackFooter.social && data.contentstackFooter.social.social_share.map(
              (social, index) => {
                return (
                  <a
                    href={social.link.href}
                    title={social.link.title.toLowerCase()}
                    key={index}
                    className="footer-social-links"
                  >
                    <img src={social.icon.url} alt='social-icon' />
                  </a>
                )
              }
            )}
          </div>
        </div>
      </div>
      <div className="copyright">
        {data && data.contentstackFooter && data.contentstackFooter.copyright
          ? ReactHtmlParser(data.contentstackFooter.copyright)
          : ""}
      </div>
    </footer>
  )
}

export default Footer
